import React, { useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Button from '@mui/material/Button'
import makeStyles from '@mui/styles/makeStyles'
import { displaySnackbar } from '../../actions/main'
import styles from './_styles/saveButtonsStyles'
import { useAppDispatch } from '../../store'

export default function LoadingButton(props: any) {
    // @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { buttonsContain... Remove this comment to see the full error message
    const useStyles = makeStyles(styles)
    const classes = useStyles()
    const {
        label,
        action,
        mustDispatchSuccess = true,
        mustDispatchError = true,
        disableCondition = false,
        ...rest
    } = props
    const [loading, setLoading] = useState(false)
    const dispatch = useAppDispatch()

    const handleAction = () => {
        setLoading(true)
        action()
            .then((successMsg: any) => {
                if (mustDispatchSuccess) dispatch(displaySnackbar('success', successMsg))
                setLoading(false)
            })
            .catch((errorMsg: any) => {
                setLoading(false)
                if (mustDispatchError) dispatch(displaySnackbar('error', errorMsg))
            })
    }

    return (
        // @ts-expect-error TS(2339) FIXME: Property 'buttonHolder' does not exist on type 'Cl... Remove this comment to see the full error message
        <div className={classes.buttonHolder}>
            <Button
                {...rest}
                elevation={0}
                disabled={loading || disableCondition}
                onClick={() => handleAction()}
                style={{
                    width: '100%',
                }}
            >
                {/* @ts-expect-error TS(2339) FIXME: Property 'buttonProgress' does not exist on type '... Remove this comment to see the full error message */}
                {loading ? <CircularProgress size={24} className={classes.buttonProgress} /> : label}
            </Button>
        </div>
    )
}
